import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, errFrom } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { BrandMark } from "../components/AppShell";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";

export default function SetPassword() {
  const { token } = useParams();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState(null);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/invite-info", { params: { token } });
        setInfo(data);
      } catch (e) {
        setErr(errFrom(e));
      }
    })();
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return toast.error("Passwords don't match");
    if (password.length < 8) return toast.error("Password must be at least 8 characters");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/set-password", { token, password });
      setUser(data);
      toast.success("Welcome aboard! Let's get you onboarded.");
      nav("/employee/onboarding", { replace: true });
    } catch (e) { toast.error(errFrom(e)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] p-6">
      <form onSubmit={submit} className="w-full max-w-md brand-surface rounded-2xl p-8 space-y-6" data-testid="set-password-form">
        <BrandMark size={36} />
        {err ? (
          <div className="text-center py-6">
            <h1 className="font-heading text-2xl font-bold">Invite expired</h1>
            <p className="text-zinc-400 mt-2 text-sm">{err}</p>
            <p className="text-zinc-500 mt-4 text-sm">Please ask your admin to resend your invite.</p>
          </div>
        ) : !info ? (
          <div className="flex justify-center py-10"><div className="w-8 h-8 border-2 border-[#FF3B30] border-t-transparent rounded-full animate-spin" /></div>
        ) : (
          <>
            <div>
              <div className="text-overline mb-2">You're invited</div>
              <h1 className="font-heading text-3xl font-bold tracking-tight">Welcome, {info.name}</h1>
              <p className="text-zinc-500 text-sm mt-2">Set a password to activate your account. You'll be guided through onboarding next.</p>
              <div className="text-xs text-zinc-600 mt-3">Signing in as <span className="text-zinc-300">{info.email}</span></div>
            </div>
            <div className="space-y-4">
              <div>
                <Label className="text-zinc-400 text-xs uppercase tracking-wider">Create password</Label>
                <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                  className="mt-2 bg-[#0A0A0A] border-white/10 h-12" data-testid="set-password-input" />
              </div>
              <div>
                <Label className="text-zinc-400 text-xs uppercase tracking-wider">Confirm password</Label>
                <Input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)}
                  className="mt-2 bg-[#0A0A0A] border-white/10 h-12" data-testid="set-password-confirm-input" />
              </div>
            </div>
            <Button type="submit" disabled={loading}
              className="w-full h-12 bg-[#FF3B30] hover:bg-[#E02920] text-white font-semibold" data-testid="set-password-submit-button">
              {loading ? "Activating…" : "Activate account"}
            </Button>
          </>
        )}
      </form>
    </div>
  );
}
